import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import ListPanel from '../../../components/list-panel/ListPanel';
import { view, store } from 'react-easy-state';
import CreateEntityModal from './entity-modal/CreateEntityModal';
import RESTService from '../../../services/RESTService';
import RoutingService from '../../../services/RoutingService';
import TimeAgo from 'react-timeago';
import Spinner from '../../../components/spinner/Spinner';
import CommonService from '../../../services/CommonService';
import DialogModal from '../../../components/dialog-modal/DialogModal';
import _ from 'lodash';
import EntityFieldPicker from './entity-field-picker/EntityFieldPicker';
import EditEntityModal from './entity-modal/EditEntityModal';
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();
class EntityList extends ComponentHelper {
	listData = store({
		searchText: '',
		entities: [],
		entityMap: {},
		createOpen: false,
		showDeleteModal: false,
		showRemoveModal: false,
		editOpen: false,
		loading: true,
		detailsOpen: '',
		toDelete: null,
		openEntity: null,
		showNewField: false,
		editing: null,
		toEdit: { displayName: '', title: '' },
		newField: {
			fieldName: '',
			fieldType: 'string',
			arrFieldType: 'string',
			relation: '',
			schema: {
				title: '',
				properties: {}
			}
		}
	});
	formData = store({
		displayName: '',
		fieldName: '',
		fieldType: 'string',
		arrFieldType: 'string',
		relation: '',
		schema: {
			properties: {}
		}
	});
	constructor(props) {
		super(props);
		this.autoBindAll(this, null, true);
	}

	componentDidMount() {
		connect
			.getEntities()
			.then(res => {
				this.listData.entities = res.data;
				this.listData.entityMap = CS.mapByParam('name', res.data);
				this.listData.loading = false;
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	onSearchChange(evt) {
		this.listData.searchText = evt.target.value;
	}

	onCreate() {
		this.listData.createOpen = true;
	}

	onEdit(evt) {
		let id = evt.target.dataset.id;
		if (id) {
			let e = this.listData.entityMap[id];
			this.listData.toEdit = { displayName: e.displayName, title: e.schema.title, entity: e };
			this.listData.editOpen = true;
		}
	}

	onDelete(evt) {
		let id = evt.target.dataset.id;
		if (id) {
			this.listData.toDelete = id;
			this.listData.showDeleteModal = true;
		}
	}

	onConfirmDelete() {
		let ent = this.listData.entityMap[this.listData.toDelete];
		if (ent) {
			connect
				.deleteEntity(ent.name)
				.then(() => {
					this.toggleDeleteModal();
					this.componentDidMount();
					RS.showSuccess();
				})
				.catch(err => {
					RS.smartError(err);
					this.toggleDeleteModal();
				});
		}
	}

	onConfirmRemove() {
		let e = this.listData.openEntity;
		if (e.schema.properties[this.listData.toRemove]) {
			delete e.schema.properties[this.listData.toRemove];
			this.updateEntity(e).then(() => {
				this.toggleRemoveModal();
				this.listData.toRemove = null;
			});
		}
	}

	updateEntity(e) {
		return connect
			.updateEntity(e)
			.then(() => {
				RS.showSuccess();
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	toggleRemoveModal() {
		this.listData.showRemoveModal = !this.listData.showRemoveModal;
	}

	toggleDeleteModal() {
		this.listData.showDeleteModal = !this.listData.showDeleteModal;
	}

	closeCreate() {
		this.listData.createOpen = false;
		this.formData = store({
			displayName: '',
			fieldName: '',
			fieldType: 'string',
			arrFieldType: 'string',
			relation: '',
			schema: {
				title: '',
				properties: {}
			}
		});
	}

	onEntityCreated(entity) {
		this.listData.entities.push(entity);
		this.formData.fieldName = '';
		this.formData.fieldType = 'string';
		this.formData.arrFieldType = 'string';
		this.data.relation = '';
		this.closeCreate();
		this.componentDidMount();
	}

	buildEntityList() {
		if (this.listData.loading) {
			return <Spinner text="Loading..." />;
		}
		let ents = this.listData.entities;
		if (ents.length <= 0) {
			return <div className="empty-list">Your environment has no entities yet.</div>;
		}
		let items = [];
		for (let i = 0; i < ents.length; i++) {
			let en = ents[i];
			if (en.displayName.indexOf(this.listData.searchText) >= 0) {
				items.push([
					<div className="list-item hbox vcenter" key={'list-item-' + en.name} data-id={en.name} onClick={this.openEntity}>
						<div className="name grow-1 ellipse" title={en.displayName}>
							{en.displayName}
						</div>
						<div className="desc grow-1 ellipse" title={en.schema.title}>
							{en.schema.title}
						</div>
						<div className="created grow-1">
							<TimeAgo date={en.creationDate} />
						</div>
						<div className="actions hbox vcenter grow-1">
							<div className="action vbox hcenter vcenter" data-rh="Edit Entity" data-rh-at="top" data-id={en.name} onClick={this.onEdit}>
								<i className="mdi mdi-pencil" data-id={en.name} />
							</div>
							<div className="action vbox hcenter vcenter" data-rh="Delete Entity" data-rh-at="top" data-id={en.name} onClick={this.onDelete}>
								<i className="mdi mdi-delete" data-id={en.name} />
							</div>
							<i className={`mdi mdi-chevron-${this.listData.openEntity && en.name === this.listData.openEntity.name ? 'up' : 'down'}`} />
						</div>
					</div>,
					this.buildOpenEntity(en)
				]);
			}
		}
		return items;
	}

	openEntity(evt) {
		let id = evt.currentTarget.dataset.id;
		if (
			id &&
			(this.listData.openEntity && id === this.listData.openEntity.name) &&
			!evt.target.classList.contains('mdi-delete') &&
			!evt.target.classList.contains('mdi-key')
		) {
			this.listData.detailsOpen = 'close';
			setTimeout(() => {
				this.listData.openEntity = null;
			}, 50);
			return;
		}
		let classes = evt.target.classList;
		if ((id && (!classes.contains('mdi') && !classes.contains('action'))) || classes.contains('mdi-chevron-down')) {
			let entity = this.listData.entityMap[id];
			if (entity) {
				this.listData.openEntity = entity;
				this.clearNewField();
				setTimeout(() => {
					this.listData.detailsOpen = 'open';
				}, 100);
			}
		}
	}

	onAddField() {
		this.listData.showNewField = true;
	}

	onFieldAdded() {
		let e = this.listData.openEntity;
		if (this.listData.editing) {
			delete e.schema.properties[this.listData.editing];
		}
		let newProp = this.listData.newField.schema.properties;
		let name = Object.keys(newProp)[0];
		e.schema.properties[name] = newProp[name];
		this.updateEntity(e);
		this.clearNewField();
	}

	clearNewField() {
		this.listData.newField = {
			fieldName: '',
			fieldType: 'string',
			arrFieldType: 'string',
			relation: '',
			schema: {
				properties: {}
			}
		};
		this.listData.editing = null;
		this.listData.showNewField = false;
	}

	removeField(evt) {
		let field = evt.target.dataset.field;
		if (field) {
			this.listData.toRemove = field;
			this.toggleRemoveModal();
		}
	}

	editField(evt) {
		let field = evt.target.dataset.field;
		if (field) {
			let allTypes = ['string', 'number', 'integer', 'boolean', 'array'];
			let e = this.listData.openEntity;
			this.listData.editing = field;
			let prop = e.schema.properties[field];
			let n = this.listData.newField;
			n.fieldName = field;
			n.fieldType = prop.type;
			if (allTypes.indexOf(prop.type) < 0) {
				n.relation = n.fieldType;
				n.fieldType = 'entity';
			}
			if (prop.type === 'array') {
				n.arrFieldType = prop.items.type;
				if (allTypes.indexOf(n.arrFieldType) < 0) {
					n.relation = n.arrFieldType;
					n.arrFieldType = 'entity';
				}
			}
			this.listData.showNewField = true;
		}
	}

	buildOpenEntity(current) {
		let e = this.listData.openEntity;
		if (e && e.name === current.name) {
			return (
				<div className={`entity-details ${this.listData.detailsOpen}`} key={`details-open-${e.name}`}>
					<div className="field-headers hbox vcenter">
						<div className="label grow-1">Field Name</div>
						<div className="label grow-1">Field Type</div>
						<div className="add-btn hbox vcenter" onClick={this.onAddField}>
							<i className="mdi mdi-plus" /> Add Field
						</div>
					</div>
					{this.listData.showNewField && (
						<EntityFieldPicker entities={this.listData.entities} formData={this.listData.newField} afterAdd={this.onFieldAdded} />
					)}
					{this.buildEntityFields(e)}
				</div>
			);
		}
		return '';
	}

	getTypeName(type) {
		if (this.listData.entityMap[type]) {
			return this.listData.entityMap[type].displayName;
		}
		return type;
	}

	buildEntityFields(e) {
		let fields = Object.keys(e.schema.properties);
		let items = [];
		_.forEach(fields, fieldKey => {
			let type = e.schema.properties[fieldKey].type;
			if (type === 'array') {
				type = `${type} of ${this.getTypeName(e.schema.properties[fieldKey].items.type)}`;
			}
			items.push(
				<div className="field-row hbox vcenter" key={`field-row-${e.displayName}-${fieldKey}`}>
					<div className="field-item grow-1">{fieldKey}</div>
					<div className={`field-item ${e.schema.properties[fieldKey].type !== 'array' ? 'type' : ''} grow-1`}>{this.getTypeName(type)}</div>
					<div className="actions hbox vcenter hright">
						<i className="mdi mdi-pencil" data-rh="Edit Field" data-rh-at="top" data-field={fieldKey} onClick={this.editField} />
						<i className="mdi mdi-close" data-field={fieldKey} onClick={this.removeField} />
					</div>
				</div>
			);
		});
		return items;
	}

	closeEdit() {
		this.listData.editOpen = false;
	}

	onEntityEdited() {
		RS.showSuccess();
		this.closeEdit();
		this.listData.toEdit = {};
		this.componentDidMount();
	}

	render() {
		let { searchText, createOpen, entities, showDeleteModal, showRemoveModal, editOpen, toEdit } = this.listData;
		return (
			<div className="entity-list-view animated fadeIn">
				<div className="entities-list-header hbox vcenter hright">
					<div className="desc-text">
						Entities are data models that describe the shape of your resources. They consist of several fields while each field can store various
						types of data (e.g: text, numbers or booleans). A field can also be a reference to another model, which allows you to build a complex
						graph of data.
					</div>
					<div className="search-ctn hbox vcenter">
						<i className="mdi mdi-magnify" />
						<input className="search-input" value={searchText} onChange={this.onSearchChange} placeholder="Search Entities..." />
					</div>
				</div>
				<ListPanel
					name="Entity List"
					className="entities-list-view"
					labels={['name', 'description', 'created', 'actions']}
					onCreate={this.onCreate}
					listItems={this.buildEntityList()}
				/>
				<CreateEntityModal
					isOpen={createOpen}
					formData={this.formData}
					entities={entities}
					onClose={this.closeCreate}
					onComplete={this.onEntityCreated}
				/>
				<EditEntityModal isOpen={editOpen} formData={toEdit} onClose={this.closeEdit} onComplete={this.onEntityEdited} />
				<DialogModal
					isOpen={showDeleteModal}
					type="warning"
					showCancelButton={true}
					cancelBtnText="Cancel"
					confirmBtnText="Delete"
					text="Deleting an entity cannot be undone"
					title="Are you sure?"
					onConfirm={this.onConfirmDelete}
					onCancel={this.toggleDeleteModal}
				/>
				<DialogModal
					isOpen={showRemoveModal}
					type="warning"
					showCancelButton={true}
					cancelBtnText="Cancel"
					confirmBtnText="Delete"
					text="Deleting a field cannot be undone"
					title="Are you sure?"
					onConfirm={this.onConfirmRemove}
					onCancel={this.toggleRemoveModal}
				/>
			</div>
		);
	}
}

export default view(EntityList);



// WEBPACK FOOTER //
// ./src/views/entities-panel/entity-list/EntityList.js